{
  "prospect": {
    "title": "Demande préalable",
    "subtitle": "Complétez les informations client, envoyez votre demande et validez la réponse du fabricant.",
    "stages": {
      "client": "Informations client",
      "request": "Demande de prise en charge préalable",
      "response": "Retour du fabricant après demande de prise en charge"
    },
    "normalOption": "OPTION 1 : Toutes marques, je ne connais pas le process; Je fais une demande de prise en charge auprès du fabricant",
    "expertOption": "OPTION 2 : Uniquement pour PRAMAC, RUBI, ABAC et LECIA ... Process EXPERT, je connais et sélectionne directement le réparateur",
    "privacy": "Les coordonnées du client sont utilisées pour traiter cette demande de réparation et contacter le client.",
    "pictureTitle": "Ajouter des photos demandées sur le modèle pour compléter le dossier",
    "pictureHint": "Cliquer sur l’option de votre choix ci-dessous",
    "pictureNumber": "Photo-{count}",
    "referenceImage": "Modèle de photos pour la demande préalable",
    "documentTitle": "Ajouter des pièces supplémentaires à joindre au dossier",
    "documentNumber": "Document-{count}",
    "moreInfo": "Détailler les informations permettant de faciliter la prise en charge",
    "moreInfoHint": "(Désignation modèle exact si non précisé précédemment, Référence Fournisseur, Taille, Couleur, etc)",
    "moreInfoPlaceholder": "Exemple : la fermeture éclair a arraché toutes les coutures",
    "acknowledge": "J'ai bien intégré toutes ces informations",
    "validateRequest": "Valider la demande préalable",
    "send": "Envoyer au réparateur",
    "sendTitle": "Demande de prise en charge préalable au réparateur",
    "sendInformation": "Tous les documents et commentaires seront envoyés au réparateur pour un diagnostic complet.",
    "previewPdf": "Demande de prise en charge",
    "repairerEmail": "Envoyer la demande au réparateur par email",
    "repairerEmailPlaceholder": "Email du réparateur",
    "sendNotice": "Suite à cette demande, le dossier sera sauvegardé dans l'attente du retour du réparateur",
    "waiting": "Demande envoyée. En attente de la réponse du fabricant. Vous pouvez aussi saisir une réponse reçue directement.",
    "expertSummary": "Process expert — aucune demande envoyée au fabricant.",
    "responseReceived": "Vérifiez et validez la réponse du fabricant avant de continuer.",
    "refresh": "Actualiser la réponse",
    "refreshTitle": "Actualiser la réponse du fabricant ?",
    "refreshMessage": "Vos modifications non enregistrées seront remplacées par la réponse enregistrée.",
    "supportNumber": "N° de la demande de prise en charge",
    "supportNumberPlaceholder": "Saisir le numéro de prise en charge",
    "comment": "Commentaire",
    "commentPlaceholder": "Précisez le retour du fabricant et les instructions utiles au magasin",
    "responseAttachment": "Ajouter une pièce jointe",
    "manufacturerDecision": "Prise en charge par le fabricant",
    "confirmResponse": "Confirmer le retour du fabricant",
    "confirmResponseMessage": "La confirmation engendre des actions sur le dossier, vous ne pourrez pas revenir en arrière",
    "retryContinuation": "Utilisez Continuer pour recharger le résultat enregistré sans soumettre à nouveau la décision.",
    "unavailable": "Cette étape de la demande préalable n'est pas modifiable. Rouvrez le dossier pour actualiser son état.",
    "mobileHint": "Ajoutez vos fichiers, puis confirmez l'ajout sur votre ordinateur.",
    "imageFormats": "JPG, JPEG ou PNG",
    "anyFormat": "Tout format de document",
    "choices": {
      "PRODUCT_REPAIR_WITHOUT_GUARANTEE": "Retour du produit pour diagnostic",
      "TECHNICIAN_ON_SITE_INTERVENTION": "Intervention sur site d'un technicien",
      "CREDIT_OR_REFUND": "Avoir / Remboursement",
      "PRODUCT_REPLACEMENT": "Echange par un produit neuf",
      "REJECT_PROSPECT": "Refus - Non réparation et clôture du dossier",
      "OTHER": "Autre"
    }
  },
  "search": "Rechercher un dossier",
  "list": {
    "title": "Dossiers de réparation",
    "subtitle": "Suivez les dossiers de réparation rattachés à votre centre d'exploitation.",
    "newRepairFile": "Nouveau dossier"
  },
  "storeOriginWarning": {
    "title": "Ce dossier a été initié par votre distributeur pour votre compte.",
    "message": "Veuillez confirmer que vous avez pris connaissance de cette information avant d'ouvrir le dossier.",
    "checkbox": "J'ai pris connaissance de cette information.",
    "confirm": "Ouvrir le dossier"
  },
  "shipping": {
    "title": "Expédition",
    "subtitle": "Préparez et générez l’expédition du dossier de réparation",
    "backToTransport": "Retour aux options de transport",
    "transporter": {
      "chronopost": "Chronopost",
      "subtitle": "Enlèvement express avec étiquette automatique"
    },
    "departure": "Départ",
    "delivery": "Livraison",
    "package": "Colis",
    "constraints": "Contraintes Chronopost",
    "summaryInProgress": "Dossier en cours d'expédition",
    "address": "Adresse",
    "city": "Ville",
    "departureSubtitle": "Adresse d'enlèvement",
    "deliverySubtitle": "Adresse du réparateur",
    "constraintsSubtitle": "Date et créneau d'enlèvement",
    "collectTitle": "Générer une étiquette sans enlèvement",
    "collectSubtitle": "Générez l’étiquette de transport sans programmer d’enlèvement.",
    "earliestPickupTime": "Heure d'enlèvement au plus tôt",
    "latestPickupTime": "Heure d'enlèvement au plus tard",
    "shipmentCreationDeadline": "Heure limite de création de l'expédition",
    "pickupDate": "Date d'enlèvement",
    "weight": "Poids",
    "width": "Largeur",
    "length": "Longueur",
    "checkFeasibility": "Vérifier la disponibilité de l'enlèvement",
    "generateShipment": "Générer l'expédition",
    "message": {
      "feasibilitySuccess": "L'enlèvement Chronopost est disponible.",
      "generateSuccess": "L'expédition Chronopost a été créée.",
      "missingService": "Aucun service d'expédition Chronopost n'est disponible.",
      "invalidConstraints": "Les contraintes Chronopost ne permettent pas de programmer cette expédition.",
      "invalidCollection": "La date ou l'heure d'enlèvement n'est plus valide. Actualisez les contraintes et choisissez une autre date d'enlèvement.",
      "chronopostError": "Chronopost n'a pas pu traiter la demande. Réessayez.",
      "loadError": "Impossible de charger les informations d'expédition."
    }
  },
  "customerServiceTransport": {
    "title": "Demande de transport au service client",
    "subtitle": "Renseignez les informations nécessaires à l'organisation de l'enlèvement",
    "back": "Retour aux options de transport",
    "retry": "Réessayer",
    "submit": "Envoyer la demande",
    "summary": "Demande de transport en préparation",
    "transportTitle": "Transport organisé par le service client du réparateur",
    "transportSubtitle": "Le réparateur utilisera ces informations pour organiser l'enlèvement et vous transmettre les documents de transport.",
    "steps": {
      "step1": {
        "title": "Lieu et coordonnées d'enlèvement",
        "subtitle": "Sélectionnez le lieu et vérifiez le contact et l'adresse."
      },
      "step2": {
        "title": "Informations colis",
        "subtitle": "Vérifiez les dimensions et le conditionnement du colis."
      },
      "step3": {
        "title": "Disponibilités d'enlèvement",
        "subtitle": "Indiquez les jours et créneaux disponibles."
      }
    },
    "location": {
      "title": "Lieu d'enlèvement",
      "subtitle": "Sélectionnez le lieu",
      "customer": "Chez le client",
      "site": "Au centre d'exploitation"
    },
    "contact": {
      "title": "Contact et adresse d'enlèvement",
      "subtitle": "Ces informations restent modifiables pour cette demande uniquement.",
      "lastname": "Nom",
      "firstname": "Prénom",
      "email": "Email",
      "phone": "Téléphone",
      "addressName": "Nom du site",
      "addressNumber": "N°",
      "addressStreet": "Rue",
      "addressComplement1": "Complément d'adresse 1",
      "addressComplement2": "Complément d'adresse 2",
      "zipCode": "Code postal",
      "city": "Ville",
      "country": "Pays"
    },
    "package": {
      "title": "Informations colis",
      "subtitle": "Indiquez les caractéristiques du colis prêt à être enlevé.",
      "weight": "Poids (kg)",
      "length": "Longueur (cm)",
      "width": "Largeur (cm)",
      "height": "Hauteur (cm)",
      "pallet": "Transport sur palette"
    },
    "comment": {
      "label": "Commentaire de transport",
      "placeholder": "Préciser le/les jours de ramasse souhaités, précisions d'instruction pour le chauffeur, emplacement spécifique du produit..."
    },
    "planning": {
      "removeSlot": "Supprimer le créneau",
      "days": {
        "monday": "Lundi",
        "tuesday": "Mardi",
        "wednesday": "Mercredi",
        "thursday": "Jeudi",
        "friday": "Vendredi"
      },
      "errors": {
        "invalidRange": "L'heure de fin doit être postérieure à l'heure de début.",
        "overlap": "Les créneaux ne peuvent pas se chevaucher.",
        "tooManySlots": "Deux créneaux maximum sont autorisés par jour."
      }
    },
    "recipient": {
      "title": "Service client destinataire",
      "email": "Adresse e-mail du réparateur",
      "phone": "Téléphone du service client",
      "customerNumber": "Votre numéro client chez le réparateur"
    },
    "documents": {
      "title": "Documents",
      "customerServiceForm": "Fiche du service après-vente client",
      "order": "Ordre de réparation"
    },
    "summarySections": {
      "location": "Enlèvement",
      "pickupLocation": "Lieu",
      "contact": "Contact",
      "address": "Adresse",
      "city": "Ville",
      "package": "Colis",
      "dimensions": "Dimensions (L x l x H)",
      "comment": "Commentaire"
    },
    "message": {
      "loadError": "Les informations de transport n'ont pas pu être chargées. Réessayez avant d'envoyer la demande.",
      "success": "Demande de transport envoyée"
    }
  },
  "finalization": {
    "title": "Finalisation du dossier nº{number}",
    "subtitle": "Suivez les 3 étapes obligatoires ci-dessous pour déclencher le suivi de votre réparation. Aucune ne peut être omise.",
    "subtitleWithoutTracking": "Suivez les 3 étapes ci-dessous pour déclencher le suivi de votre réparation.",
    "required": "Obligatoire",
    "repairerNumber": "Numéro de réparateur",
    "repairerNumberPlaceholder": "Saisir le numéro",
    "download": "Télécharger",
    "redownload": "Re-télécharger",
    "trackingNumber": "Numéro de suivi",
    "trackingNumberPlaceholder": "XR123456789FR",
    "shareWithClient": "Client",
    "clientEmail": "Adresse e-mail du client",
    "shareWithLogisticsContact": "Préparateur logistique",
    "logisticsContactEmail": "Adresse e-mail du préparateur logistique",
    "shareWithSales": "Équipe commerciale",
    "salesEmail": "Adresse e-mail du contact commercial",
    "finishLater": "Terminer plus tard",
    "activateTracking": "Déclencher le suivi du dossier",
    "sections": {
      "transportDetails": "Renseigner les informations de transport",
      "documents": "Imprimer les documents pour le réparateur",
      "documentsSubtitle": "Ces documents doivent impérativement être glissés dans le colis. Sans eux, votre produit ne pourra pas être pris en charge ni réparé par le technicien.",
      "activateTracking": "Activer le suivi du dossier",
      "activateTrackingSubtitle": "En confirmant, vous déclarez avoir renseigné le numéro de suivi et placé l'ensemble des documents dans le colis. Le suivi de votre réparation sera alors activé.",
      "activateWithoutTrackingSubtitle": "En confirmant, vous déclarez avoir placé l'ensemble des documents dans le colis. Le suivi de votre réparation sera alors activé."
    },
    "documentsIncluded": {
      "repairOrder": "Ordre de réparation",
      "guaranteeExtensionProof": "Justificatif d'extension de garantie",
      "purchaseProof": "Justificatif d'achat",
      "asbestosProof": "Justificatif amiante",
      "forceSupportProof": "Justificatif de prise en charge forcée",
      "batteryLabel": "Étiquette batterie",
      "transportLabel": "Étiquette de transport",
      "transporterRepairerDocument": "Document transporteur pour le réparateur"
    },
    "documentPlacements": {
      "stickOnParcel": "À coller sur le colis",
      "putInParcel": "À mettre dans le colis"
    },
    "message": {
      "trackingRequired": "Un numéro de suivi est obligatoire",
      "downloadRequired": "Téléchargez les documents du dossier avant de le finaliser",
      "success": "Dossier finalisé"
    }
  },
  "create": {
    "title": "Dossier en création",
    "continue": "Continuer",
    "quit": "Quitter",
    "loadError": "Le dossier de réparation n'a pas pu être chargé.",
    "quitModal": {
      "title": "Quitter la création du dossier ?",
      "message": "Ce brouillon de dossier sera supprimé. Cette action est définitive.",
      "validate": "Supprimer le brouillon",
      "cancel": "Continuer la création"
    },
    "leaveModal": {
      "title": "Vous quittez le dossier",
      "subtitle": "Choisissez si vous souhaitez reprendre ce dossier plus tard ou l'abandonner.",
      "reasonTitle": "Pour quels motifs ?",
      "reasonSubtitle": "Le dossier sera visible dans le tableau sous le statut « Abandon ».",
      "stepOne": "1/2",
      "stepTwo": "2/2",
      "saveAndLeave": "Revenir sur la création de dossier plus tard",
      "abandon": "Abandonner le dossier",
      "confirmAbandon": "Abandonner le dossier",
      "recycle": "Proposer solution Recyclage/Rachat",
      "recyclingTitle": "Solution Recyclage/Rachat",
      "abandonHelp": "L'abandon clôture le dossier avec le motif sélectionné.",
      "detail": "Motif",
      "reasons": {
        "deadlineTooLong": "Délai trop long",
        "noPackage": "Pas de forfait",
        "other": "Autre",
        "repairTooExpensive": "Forfait trop cher, pas d'achat immédiat",
        "repairTooExpensiveBuyCommon": "Réparation trop chère, rachat d’un produit de la ",
        "buySameBrand": "même marque",
        "buyOtherBrand": "d'une autre marque",
        "repairTooExpensiveBuySame": "Réparation trop chère, rachat d’un produit de la même marque",
        "repairTooExpensiveBuyOther": "Réparation trop chère, rachat d’un produit d'une autre marque"
      }
    },
    "subtitles": {
      "product": "Sélectionnez le produit en panne concerné",
      "breakdown": "Décrivez le motif de la panne",
      "guarantee": "Évaluez la prise en charge garantie",
      "pricing": "Sélectionnez la tarification adaptée",
      "clientInfo": "Renseignez les informations client",
      "transport": "Configurez le transport"
    },
    "stepper": {
      "ariaLabel": "Étapes de création du dossier de réparation"
    },
    "steps": {
      "product": "Produit",
      "breakdown": "Motif de la panne",
      "guarantee": "Évaluation de garantie",
      "pricing": "Tarification",
      "clientInfo": "Information client",
      "transport": "Transport"
    },
    "clientInfo": {
      "title": "Informations client",
      "subtitle": "Vérifiez les coordonnées utilisées pour créer le dossier. Les champs sont préremplis avec votre compte et le centre d'exploitation.",
      "company": "Nom de l'Entreprise",
      "companyPlaceholder": "Nom de l'entreprise",
      "worksiteCode": "Code d'imputation",
      "worksitePlaceholder": "Code chantier, code interne, centre de coût...",
      "worksiteMax": "Le code doit contenir 25 caractères maximum",
      "worksiteFormat": "Utilisez uniquement des lettres majuscules, chiffres et espaces",
      "lastname": "Nom / prénom",
      "lastnamePlaceholder": "Nom du contact",
      "email": "Email",
      "emailPlaceholder": "Email de contact",
      "phone": "Téléphone",
      "phonePlaceholder": "Téléphone"
    },
    "transport": {
      "addressesTitle": "Informations sur les adresses",
      "addressSubtitle": "Sélectionnez une modalité de transport et confirmez les adresses de départ et de retour.",
      "choiceTitle": "Choix du transport",
      "choiceSubtitle": "Sélectionnez le matériel et une option de transport.",
      "modeLabel": "Modalité de transport",
      "modePlaceholder": "Sélectionnez une modalité",
      "addressSectionTitle": "Renseignez les adresses",
      "addressFlow": {
        "departure": "Départ",
        "repair": "Réparation",
        "return": "Retour"
      },
      "sendToRepairer": "Envoi au constructeur/réparateur",
      "distributorDropOff": "Dépôt du produit chez un distributeur",
      "departureAddress": "Adresse de départ",
      "repairAddress": "Réparateur",
      "returnAddress": "Adresse de retour",
      "addressName": "Nom de l’adresse",
      "address": "Adresse",
      "addressNumber": "N°",
      "addressStreet": "Rue",
      "addressLine2": "Complément d'adresse",
      "zipCode": "Code postal",
      "city": "CP Ville",
      "contact": "Nom du contact",
      "email": "Email",
      "phone": "Téléphone",
      "editAddress": "Modifier l'adresse",
      "editDepartureAddress": "Modifier l'adresse de départ",
      "editReturnAddress": "Modifier l'adresse de retour",
      "saveAddress": "Enregistrer l'adresse",
      "scheduleShipment": "Programmer l'expédition",
      "confirmAddress": "Confirmer les informations",
      "material": "Matériel à déclarer",
      "materialSubtitle": "Pré-sélectionné selon la panne déclaré. Ajustez les quantités si nécessaire.",
      "package": "Détails du colis (calcul automatique)",
      "packetWeight": "Poids",
      "packetLength": "Longueur (cm)",
      "packetWidth": "Largeur (cm)",
      "battery": "Batterie",
      "pallet": "Palette",
      "transporterChoiceTitle": "Choisissez le transporteur",
      "transporterChoiceSubtitle": "Les options disponibles dépendent du matériel déclaré et des dimensions du colis.",
      "materialLoadError": "Le matériel à déclarer n'a pas pu être chargé.",
      "chronopostLoadError": "Chronopost est temporairement indisponible. Les autres options de transport restent disponibles.",
      "routingDiagnostic": {
        "title": "Aucune configuration de réparateur officiel ne correspond à ce dossier.",
        "fields": {
          "manufacturer": "Constructeur",
          "category": "Catégorie",
          "subcategory": "Sous-catégorie",
          "store": "Magasin",
          "warranty": "Prise en charge de la garantie"
        },
        "warranty": {
          "without_guarantee": "Hors garantie",
          "guarantee": "Sous garantie"
        },
        "candidates": "Configurations les plus proches dans le réseau du magasin sélectionné (à confirmer par un administrateur) :",
        "missing": "conditions non satisfaites : {conditions}.",
        "limit": "Seules les 5 premières configurations parmi {count} correspondances proches sont affichées.",
        "noCandidates": "Aucune configuration liée à ce constructeur, cette catégorie ou cette sous-catégorie n'a été trouvée dans le réseau du magasin sélectionné.",
        "noConfiguration": "Aucune configuration de réparateur n'existe pour le réseau du magasin sélectionné.",
        "action": "Un administrateur doit confirmer le réparateur prévu et corriger les associations ou la prise en charge de la garantie dans sa configuration. Une seule configuration doit satisfaire toutes les conditions ci-dessus. Aucun réparateur n'a été sélectionné automatiquement."
      },
      "whitelistLoadError": "La configuration de transport du réparateur n'a pas pu être vérifiée. Réessayez avant de demander un transport organisé par le réparateur.",
      "choiceCards": {
        "immediateSubtitle": "Enlèvement et suivi Chronopost",
        "specificTitle": "Transport spécifique (messagerie)",
        "specificSubtitle": "Utilisez cette option lorsque Chronopost ne peut pas prendre en charge l’envoi, notamment en raison de dimensions hors normes.",
        "withoutTitle": "Organiser le transport par vos propres moyens",
        "withoutSubtitle": "Sans suivi logistique par l’équipe Boomerang."
      },
      "batteryModal": {
        "title": "Caractéristiques de la batterie",
        "message": "Une batterie au lithium endommagée peut court-circuiter pendant le transport et provoquer une surchauffe ou un incendie.\n\nL'expéditeur est responsable du transport et des coûts qui en résultent en cas d'accident. Les marchandises dangereuses doivent être correctement déclarées, emballées et étiquetées, et accompagnées des documents requis.\n\nLes batteries d'une capacité de 100 Wh ou plus ne sont pas acceptées par les transporteurs express (TNT, Chronopost ou UPS). Elles doivent être expédiées par messagerie et déclarées et étiquetées en conséquence. L'étiquette est disponible à la fin de cette procédure.",
        "voltage": "Tension de la batterie",
        "amperage": "Intensité de la batterie",
        "voltagePlaceholder": "18 V",
        "amperagePlaceholder": "8 Ah",
        "expressYes": "Transport express autorisé",
        "expressNo": "Transport par messagerie obligatoire",
        "checkbox": "Cas particuliers :\nDEWALT : je confirme avoir installé le capot requis sur la batterie FLEXVOLT afin qu'elle puisse être expédiée par transport express.\nFESTOOL : je confirme avoir placé la POWERSTATION sur OFF afin qu'elle puisse être expédiée par transport express.",
        "save": "Enregistrer"
      },
      "specificTransportModal": {
        "title": "Demander un transport organisé par le réparateur",
        "customerServiceForm": "Fiche du service après-vente client",
        "orderDocument": "Ordre de réparation",
        "repairerEmail": "Adresse e-mail du réparateur",
        "emailPlaceholder": "email{'@'}reparateur.fr",
        "infoTitle": "Informations complémentaires",
        "repairerCustomerServicePhone": "Téléphone du service client du réparateur",
        "repairerCustomerNumber": "Votre numéro client chez le réparateur",
        "internalOrderNumber": "Votre numéro de commande interne",
        "sendRequest": "Envoyer la demande",
        "pendingLabelMessage": "Le dossier sera sauvegardé dans l'attente de l'étiquette d'expédition.",
        "partnerProcessingMessage": "Le réparateur traitera votre demande et vous enverra l'étiquette d'expédition.",
        "alert": "Sans réponse sous 48 h, contactez l’{team}.",
        "teamLabel": "équipe Boomerang",
        "success": "Demande de transport envoyée"
      }
    },
    "product": {
      "popular": "Produits les plus populaires",
      "selectProduct": "Sélectionnez le produit",
      "manufacturerLabel": "Quelle est la marque du produit ?",
      "categoryLabel": "Quelle est la gamme du produit ?",
      "subCategoryLabel": "Quelle est la sous-gamme du produit ?",
      "manufacturerPlaceholder": "Sélectionnez la marque",
      "categoryPlaceholder": "Sélectionnez la gamme",
      "subCategoryPlaceholder": "Sélectionnez la sous-gamme",
      "noProduct": "Aucun produit",
      "notRepairable": "Non réparable",
      "loadError": "Les produits n'ont pas pu être chargés.",
      "retry": "Réessayer",
      "requestMissing": "Vous ne trouvez pas votre produit ?",
      "requestAdd": "Demander l'ajout",
      "requestModal": {
        "title": "Demander la création d'un produit",
        "message": "Ajoutez les informations visibles sur la plaque signalétique. Réponse sous 8 à 24h.",
        "manufacturer": "Marque",
        "productName": "Nom du produit",
        "productCode": "Code / référence produit",
        "email": "Email de contact",
        "senderName": "Nom de l'entreprise de votre client (pour resaisir le dossier ultérieurement)",
        "underGuarantee": "Produit sous garantie",
        "nameplate": "Plaque signalétique",
        "dropzoneTitle": "Déposez la photo de la plaque signalétique",
        "acceptedFormats": "Formats acceptés : JPG, PNG, WEBP, HEIC",
        "nameplateHint": "Photo de la plaque signalétique. Si elle est absente, ajoutez une photo du produit complet.",
        "takePhoto": "Prendre une photo",
        "removeFile": "Supprimer la photo",
        "openQr": "Ajouter via QR code",
        "qrSubtitle": "Scannez ce QR code pour prendre en photo la plaque signalétique. Cochez la case une fois cette étape validée.",
        "qrValidated": "Je confirme avoir ajouté la photo via QR code",
        "qrValidationError": "Aucune photo n'a encore été ajoutée via QR code.",
        "qrUploaded": "Photo ajoutée via QR code.",
        "submit": "Envoyer la demande (réponse sous 8-24h)",
        "cancel": "Annuler",
        "successMessage": "Votre demande de création de produit a été envoyée."
      },
      "asbestosModal": {
        "title": "Déclaration amiante",
        "message": "Le produit {productName} a-t-il été exposé à l'amiante ? Si oui, vous pouvez ajouter le certificat amiante maintenant ou le fournir plus tard.",
        "continue": "Continuer",
        "cancel": "Annuler",
        "dropzoneTitle": "Déposez le certificat amiante",
        "acceptedFormats": "Formats acceptés : PDF, JPG, PNG",
        "addFile": "Ajouter le certificat",
        "removeFile": "Supprimer le certificat"
      }
    },
    "breakdown": {
      "title": "Décrivez la panne",
      "subtitle": "Décrivez le dysfonctionnement observé. Le meilleur niveau de garantie sera calculé ensuite.",
      "descriptionLabel": "Quel problème rencontrez-vous ?",
      "descriptionPlaceholder": "Décrivez brièvement le dysfonctionnement observé",
      "typeLabel": "Type de panne",
      "typePlaceholder": "Sélectionnez le type de panne",
      "notFoundBreakdown": "Je ne trouve pas le type de panne",
      "loadError": "Les informations de panne n'ont pas pu être chargées.",
      "questionModal": {
        "title": "Questions - {breakdown}",
        "message": "Répondez aux questions associées au type de panne sélectionné."
      },
      "productType": {
        "MACHINE": "Machine",
        "BATTERY": "Batterie",
        "CHARGER": "Chargeur",
        "PRODUCT": "Produit",
        "ACCESSORY_ONE": "Accessoire 1",
        "ACCESSORY_TWO": "Accessoire 2",
        "BRIEFCASE": "Mallette",
        "PREMIUM_CONSUMABLE": "Consommable Premium",
        "PPE": "Équipement de protection individuelle",
        "EQUIPMENT": "Équipement",
        "SUB_PRODUCT": "Sous-produit",
        "PALLET": "Palette"
      }
    },
    "pricing": {
      "title": "Choisissez le magasin réparateur",
      "subtitle": "Comparez les propositions disponibles. La sélection fait entrer le dossier dans le périmètre du magasin choisi.",
      "externalRate": "Tarif externe",
      "internalRepair": "Réparation interne",
      "internalRate": "Tarif interne",
      "package": "Forfait",
      "estimate": "Devis",
      "free": "Gratuit",
      "packagePricePrefix": "Forfait à",
      "onEstimate": "Sur devis",
      "repairTime": "Délai moyen de réparation constaté",
      "days": "jours",
      "productNewPrice": "Prix de vente indicatif/public",
      "purchasedInThisStore": "Produit acheté dans ce magasin",
      "loadError": "Les options de tarification n'ont pas pu être chargées.",
      "noStore": "Aucun magasin disponible",
      "noOption": "Aucune option de tarification n'est disponible pour ce magasin.",
      "missingKeyAccountClientNumber": "Nº client manquant"
    },
    "summary": {
      "progress": "Progression",
      "progressValue": "Étape {current} sur {total}",
      "folder": "Dossier",
      "noFolder": "Aucun dossier créé",
      "creationInProgress": "Dossier en cours de création",
      "productSection": "Produit sélectionné",
      "noProduct": "Sélectionnez un produit pour créer le brouillon du dossier.",
      "manufacturer": "Marque",
      "category": "Gamme",
      "subCategory": "Sous-gamme",
      "product": "Produit",
      "serialNumber": "N° série",
      "breakdownSection": "Motif de la panne",
      "breakdown": "Description de la panne",
      "breakdownType": "Éléments en panne",
      "guaranteeSection": "Prise en charge",
      "guarantee": "Prise en charge",
      "underGuarantee": "Sous garantie",
      "outGuarantee": "Hors garantie",
      "pricingSection": "Tarification",
      "package": "Forfait",
      "amount": "Montant",
      "delay": "Délai moyen",
      "days": "{count} jours",
      "clientInfoSection": "Information client",
      "company": "Entreprise",
      "name": "Nom / prénom",
      "contact": "Contact"
    },
    "guarantee": {
      "title": "Source de garantie",
      "serialSubtitle": "Recherchez le numéro de série",
      "serialPrerequisite": "Renseignez un numéro de série valide pour poursuivre l'évaluation de garantie.",
      "serialExampleOne": "Le numéro de série se trouve généralement sur la plaque signalétique du produit.",
      "serialExampleTwo": "Saisissez le numéro de série complet pour poursuivre l'évaluation de garantie.",
      "serialFormatError": "Le numéro de série doit contenir {count} caractère(s).",
      "serialNoData": "Aucun numéro de série correspondant",
      "nameplateAlt": "Plaque signalétique du produit",
      "workflowTitle": "Évaluez la garantie",
      "workflowSubtitle": "Suivez le même parcours qu'en magasin : numéro de série, date d'achat, extension puis prise en charge forcée si nécessaire.",
      "inventoryMatch": "Ce produit existe dans votre parc. Nous utilisons la facture, la plaque signalétique, le numéro de série, le magasin et le réseau enregistrés.",
      "noInventoryMatch": "Aucun produit du parc ne correspond à ce centre d'exploitation et à ce produit. La comparaison des garanties par magasin sera utilisée.",
      "sourceTitle": "Données utilisées",
      "sourceInventory": "Produit trouvé dans le parc",
      "sourceComparison": "Comparaison des magasins éligibles",
      "invoice": "Facture client",
      "evidence": "Justificatifs",
      "available": "Disponible",
      "affectedProducts": "Éléments évalués",
      "commercialDuration": "Durée commerciale",
      "pendingComparison": "Calculée côté serveur",
      "days": "{count} jours",
      "serialStep": "1. Numéro de série",
      "serialHelp": "Saisissez ou vérifiez le numéro de série. Si le produit est dans le parc, la valeur enregistrée est utilisée.",
      "purchaseStep": "2. Date d'achat",
      "purchaseHelp": "La garantie commerciale est calculée à partir de la meilleure garantie magasin retenue.",
      "purchaseEmpty": "Renseignez une date d'achat pour calculer la couverture.",
      "commercialExpired": "La garantie commerciale est expirée. Indiquez une extension si elle existe.",
      "unknownPurchaseDate": "Je ne trouve pas la date d'achat",
      "purchaseProof": "Justificatif de date d'achat",
      "proofLater": "L'ajout de justificatif sera disponible avec les actions de preuve key-account.",
      "extensionStep": "3. Extension de garantie",
      "extensionHelp": "Indiquez la date de fin d'extension fournie par le client.",
      "extensionEmpty": "Renseignez une date d'extension pour calculer la couverture.",
      "extensionExpired": "L'extension est expirée.",
      "extensionProof": "Justificatif d'extension de garantie",
      "forceProof": "Justificatif de prise en charge forcée",
      "asbestosProof": "Justificatif amiante",
      "uploadFromDesktop": "Depuis l'ordinateur",
      "uploadViaMobile": "Via mobile",
      "uploadedProof": "Document ajouté",
      "inheritedProof": "Document du parc",
      "removeProof": "Supprimer le document",
      "mobileUploadTitle": "Ajouter le document via mobile",
      "mobileUploadHelp": "Scannez ce QR code avec un mobile, ajoutez le document, puis confirmez ici une fois l'envoi terminé.",
      "mobileUploadConfirm": "Confirmer l'envoi",
      "mobileUploadMissing": "Aucun document reçu pour le moment. Envoyez le document depuis le mobile puis réessayez.",
      "withoutExtension": "Sans extension",
      "successTitle": "Sous garantie",
      "warningTitle": "Hors garantie",
      "guaranteeTime": "Durée de garantie",
      "guaranteeTimeRemaining": "Temps restant",
      "today": "Aujourd'hui",
      "noDay": "0 jour",
      "remainingDays": "Couvert encore {count} jour(s).",
      "lastDay": "Dernier jour de garantie.",
      "noCoverageTitle": "Aucune couverture valide ?",
      "noCoverageHelp": "Vous pouvez forcer la prise en charge avec un motif ou poursuivre hors garantie.",
      "forceAction": "Forcer la prise en charge",
      "noGuaranteeAction": "Déclarer hors garantie",
      "serialNumber": "Numéro de série",
      "serialNumberNotFoundForProlongation": "Numéro de série inconnu pour la prolongation de garantie",
      "buyDate": "Date d'achat",
      "extensionDate": "Date de fin d'extension de garantie",
      "forceDescription": "Motif de prise en charge forcée",
      "results": {
        "serialCovered": "Garantie validée par le parc",
        "commercialCovered": "Garantie commerciale",
        "extensionCovered": "Extension de garantie",
        "forcedCovered": "Prise en charge forcée",
        "outGuarantee": "Hors garantie"
      },
      "forceModal": {
        "title": "Forcer la prise en charge sous garantie",
        "message": "Le système indique une prise en charge théorique mais le distributeur a tout à fait la possibilité de forcer la prise en charge sous garantie. Il vous faut expliquer clairement la raison au fabricant / réparateur afin qu’il puisse décider si la prise en charge est pertinente.",
        "reasonLabel": "Pourquoi la prise en charge devrait être sous garantie ?",
        "reasonPlaceholder": "Exemple : cette machine fut réparée chez le fabricant il y a 3 mois et est donc sous garantie.",
        "cancel": "Annuler",
        "confirm": "Valider le motif"
      },
      "exclusionModal": {
        "title": "Exclusions de la prise en charge sur ce produit"
      },
      "types": {
        "commercial": "Garantie commerciale",
        "serial": "Garantie par numéro de série",
        "extension": "Extension de garantie",
        "force": "Forcer la garantie",
        "none": "Hors garantie"
      }
    }
  },
  "guaranteeProofUpload": {
    "title": "Ajouter le justificatif",
    "subtitle": "Ajoutez le justificatif depuis votre mobile.",
    "dropzoneTitle": "Déposez le document",
    "acceptedFormats": "PDF, JPG, PNG",
    "hint": "Après l’envoi, retournez sur l’ordinateur pour confirmer.",
    "takePhoto": "Prendre une photo",
    "removeFile": "Supprimer le document",
    "submit": "Envoyer le document",
    "successTitle": "Document envoyé",
    "successMessage": "Vous pouvez retourner sur l’ordinateur et confirmer l’envoi.",
    "invalidTitle": "Lien expiré ou invalide",
    "invalidMessage": "Demandez un nouveau QR code depuis le dossier."
  },
  "additionalAttachmentUpload": {
    "title": "Ajouter une pièce jointe",
    "subtitle": "Ajoutez le document depuis votre mobile.",
    "namePlaceholder": "Nom du fichier",
    "dropzoneTitle": "Déposez le document",
    "acceptedFormats": "PDF, JPG, PNG",
    "hint": "Après l’envoi, retournez sur l’ordinateur pour confirmer.",
    "takePhoto": "Prendre une photo",
    "removeFile": "Supprimer le document",
    "submit": "Envoyer le document",
    "successTitle": "Document envoyé",
    "successMessage": "Vous pouvez retourner sur l’ordinateur et confirmer l’envoi.",
    "invalidTitle": "Lien expiré ou invalide",
    "invalidMessage": "Demandez un nouveau QR code depuis le dossier."
  },
  "productRequestUpload": {
    "title": "Ajouter une photo",
    "subtitle": "Ajoutez la photo de la plaque signalétique depuis votre téléphone.",
    "dropzoneTitle": "Déposez la photo",
    "acceptedFormats": "JPG, JPEG, PNG",
    "hint": "Photo de la plaque signalétique. Si elle est absente, ajoutez une photo du produit complet.",
    "takePhoto": "Prendre une photo",
    "removeFile": "Supprimer la photo",
    "submit": "Envoyer la photo",
    "successTitle": "Photo envoyée",
    "successMessage": "Vous pouvez retourner sur votre ordinateur pour finaliser la demande.",
    "invalidTitle": "Lien expiré ou invalide",
    "invalidMessage": "Veuillez générer un nouveau QR code depuis la demande."
  },
  "detail": {
    "title": "Détail du dossier de réparation",
    "internalCommandNumber": "N° {reference}",
    "resume": "Reprendre le dossier",
    "message": {
      "draft": "Ce dossier est en brouillon",
      "deleted": "Ce dossier a été supprimé",
      "notFound": "Dossier de réparation introuvable"
    },
    "titles": {
      "summary": "Résumé",
      "progression": "Progression",
      "pricing": "Tarification client (HT)",
      "contact": "Contact"
    },
    "alt": {
      "productImage": "Image produit"
    },
    "tabs": {
      "attachments": "Pièces jointes",
      "contact": "Contact",
      "pricing": "Tarification détaillée",
      "transport": "Adresses A/R",
      "support": "Prise en charge",
      "prospectFlow": "Demande de prise en charge préalable"
    },
    "fields": {
      "serialNumber": "Série",
      "description": "Description",
      "lastname": "Nom de l'interlocuteur",
      "email": "Email",
      "phoneNumber": "Téléphone",
      "worksiteCode": "Code spécifique",
      "clientCode": "Code client",
      "support": "Prise en charge initialement demandée",
      "gestion": "Lieu de réparation",
      "underGuarantee": "Sous garantie",
      "outGuarantee": "Hors garantie",
      "company": "Entreprise",
      "store": "Magasin",
      "address": "Adresse",
      "operatingCenter": "Centre d'exploitation",
      "transportType": "Type de transport",
      "trackingNumber": "Numéro de suivi",
      "breakdown": "Description de la panne",
      "breakdownType": "Type de panne",
      "mode": "Mode",
      "element": "Eléments concernés",
      "guarantee": "Garantie initiale",
      "day": "{count} jour",
      "days": "{count} jours"
    },
    "pricingStatus": {
      "packageValidated": "Forfait validé par le client",
      "estimateToIntegrate": "Devis à intégrer",
      "waitingCustomerDecision": "Attente décision clients sur options proposées",
      "estimateValidated": "Validation Devis par le client"
    },
    "status": {
      "inProgress": "Dossier en cours",
      "takeoverByCustomer": "Récupération par le client"
    },
    "productEndStatus": {
      "PRODUCT_REPAIRED": "Réparation de la machine",
      "PRODUCT_REPLACED_STANDARD": "Remplacement produit standard",
      "PRODUCT_REPLACED_SUPERIOR": "Remplacement produit supérieur",
      "PRODUCT_CREDIT": "Gestion par avoir",
      "PRODUCT_RECYCLED": "Non réparation : recyclage",
      "PRODUCT_RETURN_DISASSEMBLED": "Non réparation : retour de la machine démontée",
      "PROSPECT_REPAIR_WITH_GUARANTEE": "Demande préalable : Réparation de la machine sous garantie",
      "PROSPECT_REPAIR_WITHOUT_GUARANTEE": "Demande préalable : Réparation de la machine hors garantie",
      "PROSPECT_CREDIT_OR_REFUND": "Demande préalable : Avoir",
      "PROSPECT_REPLACEMENT": "Demande préalable : Echange",
      "PROSPECT_REJECT": "Demande préalable : Pas de prise en charge",
      "PROSPECT_OTHER": "Demande préalable : Autre",
      "DEFAULT": "Dossier sans remise client"
    },
    "productType": {
      "MACHINE": "Machine",
      "BATTERY": "Batterie",
      "CHARGER": "Chargeur",
      "PRODUCT": "Produit",
      "ACCESSORY_ONE": "Accessoire 1",
      "ACCESSORY_TWO": "Accessoire 2",
      "BRIEFCASE": "Mallette",
      "PREMIUM_CONSUMABLE": "Consommable Premium",
      "PPE": "Équipement de protection individuelle",
      "EQUIPMENT": "Équipement",
      "SUB_PRODUCT": "Sous-produit",
      "PALLET": "Palette"
    },
    "statusDisplay": {
      "IN_CREATION": "1.   En création",
      "TRANSPORT_GO": "2.   Enlèvement aller",
      "RECEPTION_AT_REPAIRER": "3.   Réception chez réparateur",
      "DIAGNOSTIC_MANUFACTURER_RECEIVED": "4.   Devis envoyé par le fabricant",
      "DIAGNOSTIC_MANUFACTURER_PROCESSED": "5.   Intégration devis fabricant",
      "ESTIMATE_SENT_TO_CUSTOMER": "6.   Devis envoyé au client",
      "ESTIMATE_CUSTOMER_DECISION_SENT_TO_REPAIRER": "7.   Décision client envoyée au réparateur",
      "IN_REPARATION": "8.   En réparation",
      "SENT_BACK_BY_REPAIRER": "9.   Expédition par réparateur",
      "RECEIPT_AT_STORE": "10.   Réception par distributeur",
      "SENT_AVAILABLE_TO_CUSTOMER": "11.   Client informé dispo",
      "TAKEOVER_BY_CUSTOMER": "12.   Remise au client - Cloturé",
      "NETWORK_BILLING": "13.   Facturation",
      "FINISHED": "14.   Dossier Terminé"
    },
    "transportModality": {
      "TRANSPORTER": "Transporteur",
      "DISTRIBUTOR_DROP_OFF": "Dépôt du produit chez un distributeur"
    },
    "repairLocation": {
      "externalRepairer": "Réparateur Externe",
      "storeWorkshop": "Atelier Magasin",
      "customerWorkshop": "Atelier Client"
    },
    "attachment": {
      "add": "Ajouter",
      "name": "Nom du fichier",
      "namePlaceholder": "Nom du fichier",
      "file": "Fichier",
      "modalTitle": "Ajouter une pièce jointe",
      "modalSubtitle": "Ajoutez un fichier depuis cet ordinateur ou générez un QR code pour l'ajouter depuis un mobile.",
      "acceptedFormats": "Formats acceptés : PDF, JPG, PNG, JPEG",
      "uploadViaMobile": "Ajouter via QR code",
      "mobileUploadSubtitle": "Scannez ce QR code avec un mobile pour ajouter la pièce jointe.",
      "mobileUploadConfirm": "J'ai ajouté le document",
      "mobileUploadMissing": "Aucun document n'a encore été ajouté via QR code.",
      "customerSatisfaction": "Satisfaction client",
      "permissionDenied": "Vous n'avez pas les droits requis pour visualiser les pièces jointes du dossier",
      "printPermissionDenied": "Vous n'avez pas les droits requis pour télécharger les pièces jointes du dossier",
      "packageEstimate": "Devis du forfait",
      "packingSlip": "Étiquette expédition",
      "repairOrder": "Ordre de réparation",
      "afterSaleService": "Fiche SAV client",
      "purchaseProof": "Facture client",
      "warrantyExtension": "Extension de garantie",
      "forceWarrantyExtension": "Garantie forcée",
      "asbestos": "Déclaration amiante",
      "batteryLabel": "Etiquette produit dangereux",
      "boomerangWarrantyExtension": "BL à faire signer + Certificat de garantie Boomerang",
      "deliveryNote": "BL à faire signer",
      "transporterDocumentForRepairer": "Document specifique pour ce réparateur",
      "manufacturerAttachment": "Pièce jointe fabricant",
      "prospectOrderWaiting": "Demande préalable",
      "prospectPicture": "Photo complémentaire",
      "prospectDocument": "Document complémentaire"
    },
    "comment": {
      "title": "Commentaires",
      "placeholder": "Ajouter un commentaire",
      "visibilityStore": "Rendre visible sur commentaires partagés",
      "send": "Envoyer",
      "infoAlert": "L'équipe Boomerang n'est pas alertée de vos commentaires. Afin de nous contacter, appuyer sur le Chat (bulle verte en bas à droite).",
      "invisibleToStore": "Invisible par Equipe Magasin",
      "type": {
        "STORE": "Equipe Magasin",
        "KEY_ACCOUNT": "Client Utilisateur",
        "ADMIN": "Equipe BOOMERANG",
        "EXTERNAL": "Externe",
        "REPAIRER": "Réparateur"
      }
    },
    "contact": {
      "customer": "Client",
      "store": "Magasin",
      "copySuccess": "Adresse de contact magasin copiée dans le presse-papiers",
      "copyError": "Erreur lors de la copie dans le presse-papiers",
      "storeFields": {
        "name": "Nom",
        "address": "Adresse",
        "phone": "Numéro de téléphone",
        "email": "Adresse de contact"
      }
    },
    "pricing": {
      "distributorPackageCode": "Code forfait distributeur",
      "manufacturerPackageCode": "Code forfait fabricant",
      "clientRepairPrice": "Prix de réparation",
      "transportPrice": "Prix transport",
      "managementPrice": "Prix gestion",
      "repairFund": "Fond de réparation",
      "totalClientPrice": "Prix total client (HT)",
      "customerEndCost": "Prix total client (HT)",
      "packageCode": "Code forfait fabricant",
      "packageSupportCost": "Prix de la prise en charge (HT)",
      "clientLabel": "Client",
      "estimateValidateByCustomer": "Offre validée par client",
      "estimateValidateTakeoverByCustomer": "Offre finale client",
      "comment": "Commentaires :",
      "optionStatus": {
        "PRODUCT_REPAIRED": "Réparation de la machine",
        "PRODUCT_REPLACED_STANDARD": "Remplacement produit standard",
        "PRODUCT_REPLACED_SUPERIOR": "Remplacement produit supérieur",
        "PRODUCT_CREDIT": "Gestion par avoir",
        "PRODUCT_RECYCLED": "Non réparation : recyclage",
        "PRODUCT_RETURN_DISASSEMBLED": "Non réparation : retour de la machine démontée",
        "PROSPECT_REPAIR_WITH_GUARANTEE": "Demande préalable : Réparation de la machine sous garantie",
        "PROSPECT_REPAIR_WITHOUT_GUARANTEE": "Demande préalable : Réparation de la machine hors garantie",
        "PROSPECT_CREDIT_OR_REFUND": "Demande préalable : Avoir",
        "PROSPECT_REPLACEMENT": "Demande préalable : Echange",
        "PROSPECT_REJECT": "Demande préalable : Pas de prise en charge",
        "PROSPECT_OTHER": "Demande préalable : Autre"
      }
    },
    "pricingType": {
      "package": "Forfait",
      "estimate": "Devis"
    },
    "transport": {
      "packageWeight": "Poids du colis",
      "pallet": "Transport avec palette",
      "outbound": "Transport aller",
      "outboundDepartureAddress": "ALLER - ADRESSE DE DEPART",
      "outboundDestinationAddress": "ALLER - ADRESSE DESTINATAIRE",
      "return": "Transport retour",
      "returnRepairerAddress": "RETOUR - ADRESSE RETOUR",
      "carrierContractLogin": "Identifiant du contrat transporteur",
      "addressName": "Libellé de l'adresse",
      "address": "Adresse",
      "city": "Ville",
      "transportArrangement": "Organisation du transport",
      "transporter": "Transporteur",
      "finalizationDate": "Date de finalisation du dossier",
      "pickupScheduled": "Enlèvement programmé",
      "trackingNumber": "Numéro de suivi",
      "type": {
        "IMMEDIATE_TRANSPORTER": "Transport immédiat par transporteur",
        "CUSTOMER_SERVICE_TRANSPORTER": "Transport organisé par le service client du réparateur",
        "WITHOUT_TRANSPORTER": "Transport organisé par vos propres moyens"
      }
    }
  },
  "table": {
    "reference": "Dossier",
    "store": "Nom Magasin",
    "company": "Entreprise",
    "manufacturer": "Marque",
    "product": "Produit",
    "rental": "Location",
    "status": "Statut",
    "time": "Temps",
    "date": "Date",
    "modality": "Pris en charge",
    "day": "{count} jour",
    "days": "{count} jours"
  },
  "filters": {
    "needAction": "Dossiers nécessitant une action",
    "inProgress": "Dossiers en cours uniquement",
    "rental": "Avec dossier de location uniquement",
    "creationDate": "Date de création",
    "manufacturer": "Sélectionnez la marque",
    "status": "Sélectionnez le statut",
    "store": "Sélectionnez le magasin",
    "repairCenter": "Sélectionnez le centre de réparation",
    "modality": "Sélectionnez la modalité"
  },
  "statusMacro": {
    "IN_CREATION": "En création",
    "IN_CREATION_ESTIMATE": "En création - devis",
    "IN_CREATION_PROSPECT": "En création - demande",
    "TRANSPORT_GO": "Transport aller",
    "RECEPTION_AT_REPAIRER": "Réception réparateur",
    "DIAGNOSTIC_MANUFACTURER_RECEIVED": "Diagnostic reçu",
    "DIAGNOSTIC_MANUFACTURER_PROCESSED": "Diagnostic traité",
    "ESTIMATE_SENT_TO_CUSTOMER": "Décision client - devis",
    "ESTIMATE_CUSTOMER_DECISION_SENT_TO_REPAIRER": "Devis réparateur validé",
    "IN_REPARATION": "Réparation",
    "SENT_BACK_BY_REPAIRER": "Transport retour",
    "RECEIPT_AT_STORE": "Réception magasin",
    "SENT_AVAILABLE_TO_CUSTOMER": "Attente collecte",
    "TAKEOVER_BY_CUSTOMER": "Clôturé",
    "NETWORK_BILLING": "Facturation",
    "FINISHED": "Terminé",
    "ABORT_BY_CUSTOMER": "Abandon par client"
  },
  "modality": {
    "TRANSPORTER": "Transporteur",
    "DISTRIBUTOR_DROP_OFF": "Dépôt du produit chez un distributeur"
  }
}
